import axiosInstance from 'api/axiosInstance';
import { Ticket } from 'containers/pages/CANpark/types/ticket';

export const findTickets = async (
	licenseNumber: string,
	licenseState: string,
	parkingLocationId: string,
	lookupStartDate: string | null = null,
): Promise<Ticket[]> => {
	try {
		let API_URL = `/api2.0/tickets/findTickets?licenseNumber=${licenseNumber}&licenseState=${licenseState}&parkingLocationId=${parkingLocationId}`;
		if (lookupStartDate) {
			API_URL += `&lookupStartDate=${lookupStartDate}`;
		}
		const response = await axiosInstance.get(API_URL);

		// Convert backend response to match frontend `Ticket` type
		const formattedTickets: Ticket[] = response.data.map(
			(ticket: any) =>
				({
					ticketNumber: ticket.ticketNumber,
					ticketType: ticket.ticketType,
					parkingLocationId: ticket.parkingLocationId,
					parkingZone: ticket.parkingZone,
					licenseNumber: ticket.licenseNumber,
					licenseState: ticket.licenseState,
					vehicleInfo: ticket.vehicleInfo,
					issuedBy: ticket.issuedBy, // Fetching user's name instead of ID
					comments: ticket.comments || '',
					attachments: ticket.attachments || [],
					isVoid: ticket.isVoid === 'True',
					// Default to true when the backend doesn't send the flag (older
					// backend still date-filters, so everything it returns is in-window).
					isWithinWindow:
						ticket.isWithinWindow === undefined
							? true
							: ticket.isWithinWindow === 'True',
					date: new Date(ticket.date), // Convert UTC to local time
				} as Ticket),
		);
		return formattedTickets;
	} catch (error) {
		console.error('Error fetching tickets:', error);
		throw error;
	}
};
// date:"2025-02-18T21:19:36.228Z"
// date: "2025-02-18T14:20:01.170Z"
